<template>
    <div class="card-body">
        <form @submit.prevent="triggerSave">
            <fieldset :disabled="!canEdit">
            <div class="row">
                <!-- Sección: Datos de Contratación -->
                <div class="col-12">
                    <h5 class="text-muted mb-3">Datos de Contratación</h5>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Tipo de Jornada </label>
                        <input type="text" v-model="form.workday_type" class="form-control">
                        <div v-if="errors && errors.workday_type" class="text-danger">{{ errors.workday_type[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Esquema de Contratación </label>
                        <select v-model="form.hiring_scheme" class="form-control">
                            <option value="">Seleccione...</option>
                            <option value="planta">Planta</option>
                            <option value="temporal">Temporal</option>
                            <option value="honorarios">Honorarios</option>
                        </select>
                        <div v-if="errors && errors.hiring_scheme" class="text-danger">{{ errors.hiring_scheme[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> VISA USA </label>
                        <select v-model="form.usa_visa" class="form-control">
                            <option value="">Seleccione...</option>
                            <option :value="1">Sí</option>
                            <option :value="0">No</option>
                        </select>
                        <div v-if="errors && errors.usa_visa" class="text-danger">{{ errors.usa_visa[0] }}</div>
                    </div>
                </div>

                <!-- Sección: Tabulador Salarial -->
                <div class="col-12 mt-3">
                    <h5 class="text-muted mb-3">Tabulador Salarial</h5>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Rango Mínimo </label>
                        <input type="text" v-model="form.salary_range_min" v-money="money" class="form-control">
                        <div v-if="errors && errors.salary_range_min" class="text-danger">{{ errors.salary_range_min[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Media </label>
                        <input type="text" v-model="form.salary_range_mid" v-money="money" class="form-control">
                        <div v-if="errors && errors.salary_range_mid" class="text-danger">{{ errors.salary_range_mid[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Rango Máximo </label>
                        <input type="text" v-model="form.salary_range_max" v-money="money" class="form-control">
                        <div v-if="errors && errors.salary_range_max" class="text-danger">{{ errors.salary_range_max[0] }}</div>
                    </div>
                </div>

                <!-- Sección: Datos Personales -->
                <div class="col-12 mt-3">
                    <h5 class="text-muted mb-3">Datos Personales</h5>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Género </label>
                        <select v-model="form.gender" class="form-control">
                            <option value="">Seleccione...</option>
                            <option value="masculino">Masculino</option>
                            <option value="femenino">Femenino</option>
                            <option value="otro">Otro</option>
                        </select>
                        <div v-if="errors && errors.gender" class="text-danger">{{ errors.gender[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Nacionalidad </label>
                        <input type="text" v-model="form.nationality" class="form-control">
                        <div v-if="errors && errors.nationality" class="text-danger">{{ errors.nationality[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Estado Civil </label>
                        <select v-model="form.marital_status" class="form-control">
                            <option value="">Seleccione...</option>
                            <option value="soltero">Soltero(a)</option>
                            <option value="casado">Casado(a)</option>
                            <option value="divorciado">Divorciado(a)</option>
                            <option value="viudo">Viudo(a)</option>
                        </select>
                        <div v-if="errors && errors.marital_status" class="text-danger">{{ errors.marital_status[0] }}</div>
                    </div>
                </div>

                <!-- Sección: Formación y Habilidades -->
                <div class="col-12 mt-3">
                    <h5 class="text-muted mb-3">Formación y Habilidades</h5>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Nivel Educativo </label>
                        <input type="text" v-model="form.education_level" class="form-control">
                        <div v-if="errors && errors.education_level" class="text-danger">{{ errors.education_level[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Título </label>
                        <input type="text" v-model="form.degree_title" class="form-control">
                        <div v-if="errors && errors.degree_title" class="text-danger">{{ errors.degree_title[0] }}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label> Nivel de Inglés </label>
                        <input type="text" v-model="form.english_level" class="form-control">
                        <div v-if="errors && errors.english_level" class="text-danger">{{ errors.english_level[0] }}</div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label> Experiencia Previa </label>
                        <textarea v-model="form.previous_experience" class="form-control" rows="3"></textarea>
                        <div v-if="errors && errors.previous_experience" class="text-danger">{{ errors.previous_experience[0] }}</div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label> Conocimientos de Paquetería </label>
                        <textarea v-model="form.software_skills" class="form-control" rows="3"></textarea>
                        <div v-if="errors && errors.software_skills" class="text-danger">{{ errors.software_skills[0] }}</div>
                    </div>
                </div>

                <!-- Sección: Equipo Asignado -->
                <div class="col-12 mt-3">
                    <h5 class="text-muted mb-3">Equipo de Cómputo Asignado</h5>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label> Marca del Equipo </label>
                        <input type="text" v-model="form.computer_brand" class="form-control">
                        <div v-if="errors && errors.computer_brand" class="text-danger">{{ errors.computer_brand[0] }}</div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label> Número de Serie </label>
                        <input type="text" v-model="form.computer_serial" class="form-control">
                        <div v-if="errors && errors.computer_serial" class="text-danger">{{ errors.computer_serial[0] }}</div>
                    </div>
                </div>

                <!-- Sección: Checador Digital -->
                <div class="col-12 mt-3">
                    <h5 class="text-muted mb-3">Checador Digital</h5>
                </div>

                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body text-center">
                            <div class="form-group">
                                <label> Checador Digital (Teams) </label>
                                <input type="checkbox" v-model="form.checador_enabled" class="form-control">
                                <hr>
                                <p class="fs-6 text-info">Al activar esta opción el bot de Teams enviará mensajes diarios para el registro de asistencia (Lunes a Viernes, 9:00 AM y 6:00 PM).</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 mt-3" v-if="canEdit">
                    <button type="submit" class="btn float-right btn-outline-success" :disabled="submitted">
                        <span v-if="submitted">
                            <i class="fa-solid fa-spinner fa-spin-pulse mr-1"></i> Guardando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Guardar
                        </span>
                    </button>
                </div>
            </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
import request from '@/services/request'
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "sensitive-data-tab",
    props: ['userId', 'canEdit'],
    data() {
        return {
            form: {
                id: '',
                // Campos movidos de profile.vue
                workday_type: '',
                gender: '',
                nationality: '',
                marital_status: '',
                education_level: '',
                degree_title: '',
                english_level: '',
                // Nuevos campos de la migración
                hiring_scheme: '',
                salary_range_min: 0,
                salary_range_mid: 0,
                salary_range_max: 0,
                previous_experience: '',
                software_skills: '',
                usa_visa: '',
                computer_brand: '',
                computer_serial: '',
                checador_enabled: true
            },
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            errors: {},
            submitted: false
        }
    },
    mounted() {
        // Los datos se cargan via watch
    },
    methods: {
        async triggerSave() {
            this.submitted = true;

            const data_form = new FormData();
            data_form.append('id', this.form.id);
            // Campos movidos
            data_form.append('workday_type', this.form.workday_type);
            data_form.append('gender', this.form.gender);
            data_form.append('nationality', this.form.nationality);
            data_form.append('marital_status', this.form.marital_status);
            data_form.append('education_level', this.form.education_level);
            data_form.append('degree_title', this.form.degree_title);
            data_form.append('english_level', this.form.english_level);
            // Nuevos campos
            data_form.append('hiring_scheme', this.form.hiring_scheme);
            data_form.append('salary_range_min', this.form.salary_range_min);
            data_form.append('salary_range_mid', this.form.salary_range_mid);
            data_form.append('salary_range_max', this.form.salary_range_max);
            data_form.append('previous_experience', this.form.previous_experience);
            data_form.append('software_skills', this.form.software_skills);
            data_form.append('usa_visa', this.form.usa_visa);
            data_form.append('computer_brand', this.form.computer_brand);
            data_form.append('computer_serial', this.form.computer_serial);
            data_form.append('checador_enabled', this.form.checador_enabled ? 1 : 0);

            data_form.append('_method', 'PUT');
            let _endpoint = `/users/${this.form.id}/sensitive-data`;

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    await this.successNotification(data.message);
                    this.submitted = false;
                }
            } catch (error) {
                this.submitted = false;
                this.errors = {};
                if (error.response) {
                    let info_error = await this.errorNotification(error);
                    if (info_error == 'Logout') {
                        this.$nextTick(() => {
                            location.reload()
                        })
                    } else {
                        this.errors = info_error;
                    }
                }
            }
        },
        async get_id(id) {
            let _endpoint = `/users/${id}`;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    this.form.id = id;
                    // Campos movidos
                    this.form.workday_type = data.workday_type ? data.workday_type : '';
                    this.form.gender = data.gender ? data.gender : '';
                    this.form.nationality = data.nationality ? data.nationality : '';
                    this.form.marital_status = data.marital_status ? data.marital_status : '';
                    this.form.education_level = data.education_level ? data.education_level : '';
                    this.form.degree_title = data.degree_title ? data.degree_title : '';
                    this.form.english_level = data.english_level ? data.english_level : '';
                    // Nuevos campos
                    this.form.hiring_scheme = data.hiring_scheme ? data.hiring_scheme : '';
                    this.form.salary_range_min = data.salary_range_min ? data.salary_range_min : '';
                    this.form.salary_range_mid = data.salary_range_mid ? data.salary_range_mid : '';
                    this.form.salary_range_max = data.salary_range_max ? data.salary_range_max : '';
                    this.form.previous_experience = data.previous_experience ? data.previous_experience : '';
                    this.form.software_skills = data.software_skills ? data.software_skills : '';
                    this.form.usa_visa = data.usa_visa !== null ? data.usa_visa : '';
                    this.form.computer_brand = data.computer_brand ? data.computer_brand : '';
                    this.form.computer_serial = data.computer_serial ? data.computer_serial : '';
                    this.form.checador_enabled = data.checador_enabled == 1 ? true : false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error)
                }
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success'
        })
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {
        userId: {
            immediate: true,
            handler(newId) {
                if (newId) {
                    this.get_id(newId);
                }
            }
        }
    },
}
</script>

<style scoped>
.text-muted {
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 0.5rem;
}
</style>
